/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 商品マスタ
 * @export
 * @interface MstItem
 */
export interface MstItem {
    /**
     * 
     * @type {boolean}
     * @memberof MstItem
     */
    deleteFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof MstItem
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    insertUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstItem
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstItem
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    deleteUser: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    itemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    itemName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstItem
     */
    salesStartdate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MstItem
     */
    salesEnddate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    longside: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    shortside: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    height: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    weight: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    spec: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    maxPalletQuantity: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    palletQuantityFace: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    palletQuantityTier: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    minOrderQuantity: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    orderUnitType: string | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    caseLot: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    orderUnitTypeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    replaceItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    replaceOrgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    oldItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    makerName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    jan: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    janCase: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    gtin13: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    gtin14: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    itf: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    sdp: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    orgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    makerGln: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    orgSupplierId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstItem
     */
    isDiscontinued: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstItem
     */
    isMuted: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MstItem
     */
    supplierCompanyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    supplierName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    remarks: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstItem
     */
    recencyFlg: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstItem
     */
    isInactive: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstItem
     */
    unmatchRenewal: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstItem
     */
    isAlert: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    alertTypeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstItem
     */
    alertMessage: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstItem
     */
    lastArrivalDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MstItem
     */
    lastShipDate: Date | null;
}

/**
 * Check if a given object implements the MstItem interface.
 */
export function instanceOfMstItem(value: object): value is MstItem {
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('itemName' in value) || value['itemName'] === undefined) return false;
    if (!('salesStartdate' in value) || value['salesStartdate'] === undefined) return false;
    if (!('salesEnddate' in value) || value['salesEnddate'] === undefined) return false;
    if (!('longside' in value) || value['longside'] === undefined) return false;
    if (!('shortside' in value) || value['shortside'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('spec' in value) || value['spec'] === undefined) return false;
    if (!('maxPalletQuantity' in value) || value['maxPalletQuantity'] === undefined) return false;
    if (!('palletQuantityFace' in value) || value['palletQuantityFace'] === undefined) return false;
    if (!('palletQuantityTier' in value) || value['palletQuantityTier'] === undefined) return false;
    if (!('minOrderQuantity' in value) || value['minOrderQuantity'] === undefined) return false;
    if (!('orderUnitType' in value) || value['orderUnitType'] === undefined) return false;
    if (!('caseLot' in value) || value['caseLot'] === undefined) return false;
    if (!('orderUnitTypeName' in value) || value['orderUnitTypeName'] === undefined) return false;
    if (!('replaceItemCode' in value) || value['replaceItemCode'] === undefined) return false;
    if (!('replaceOrgItemCode' in value) || value['replaceOrgItemCode'] === undefined) return false;
    if (!('oldItemCode' in value) || value['oldItemCode'] === undefined) return false;
    if (!('makerName' in value) || value['makerName'] === undefined) return false;
    if (!('jan' in value) || value['jan'] === undefined) return false;
    if (!('janCase' in value) || value['janCase'] === undefined) return false;
    if (!('gtin13' in value) || value['gtin13'] === undefined) return false;
    if (!('gtin14' in value) || value['gtin14'] === undefined) return false;
    if (!('itf' in value) || value['itf'] === undefined) return false;
    if (!('sdp' in value) || value['sdp'] === undefined) return false;
    if (!('orgItemCode' in value) || value['orgItemCode'] === undefined) return false;
    if (!('makerGln' in value) || value['makerGln'] === undefined) return false;
    if (!('orgSupplierId' in value) || value['orgSupplierId'] === undefined) return false;
    if (!('isDiscontinued' in value) || value['isDiscontinued'] === undefined) return false;
    if (!('isMuted' in value) || value['isMuted'] === undefined) return false;
    if (!('supplierCompanyId' in value) || value['supplierCompanyId'] === undefined) return false;
    if (!('supplierName' in value) || value['supplierName'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('recencyFlg' in value) || value['recencyFlg'] === undefined) return false;
    if (!('isInactive' in value) || value['isInactive'] === undefined) return false;
    if (!('unmatchRenewal' in value) || value['unmatchRenewal'] === undefined) return false;
    if (!('isAlert' in value) || value['isAlert'] === undefined) return false;
    if (!('alertTypeName' in value) || value['alertTypeName'] === undefined) return false;
    if (!('alertMessage' in value) || value['alertMessage'] === undefined) return false;
    if (!('lastArrivalDate' in value) || value['lastArrivalDate'] === undefined) return false;
    if (!('lastShipDate' in value) || value['lastShipDate'] === undefined) return false;
    return true;
}

export function MstItemFromJSON(json: any): MstItem {
    return MstItemFromJSONTyped(json, false);
}

export function MstItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstItem {
    if (json == null) {
        return json;
    }
    return {
        
        'deleteFlg': json['delete_flg'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'companyId': json['company_id'],
        'itemCode': json['item_code'],
        'itemName': json['item_name'],
        'salesStartdate': (json['sales_startdate'] == null ? null : new Date(json['sales_startdate'])),
        'salesEnddate': (json['sales_enddate'] == null ? null : new Date(json['sales_enddate'])),
        'longside': json['longside'],
        'shortside': json['shortside'],
        'height': json['height'],
        'weight': json['weight'],
        'spec': json['spec'],
        'maxPalletQuantity': json['max_pallet_quantity'],
        'palletQuantityFace': json['pallet_quantity_face'],
        'palletQuantityTier': json['pallet_quantity_tier'],
        'minOrderQuantity': json['min_order_quantity'],
        'orderUnitType': json['order_unit_type'],
        'caseLot': json['case_lot'],
        'orderUnitTypeName': json['order_unit_type_name'],
        'replaceItemCode': json['replace_item_code'],
        'replaceOrgItemCode': json['replace_org_item_code'],
        'oldItemCode': json['old_item_code'],
        'makerName': json['maker_name'],
        'jan': json['jan'],
        'janCase': json['jan_case'],
        'gtin13': json['gtin_13'],
        'gtin14': json['gtin_14'],
        'itf': json['itf'],
        'sdp': json['sdp'],
        'orgItemCode': json['org_item_code'],
        'makerGln': json['maker_gln'],
        'orgSupplierId': json['org_supplier_id'],
        'isDiscontinued': json['is_discontinued'],
        'isMuted': json['is_muted'],
        'supplierCompanyId': json['supplier_company_id'],
        'supplierName': json['supplier_name'],
        'remarks': json['remarks'],
        'recencyFlg': json['recency_flg'],
        'isInactive': json['is_inactive'],
        'unmatchRenewal': json['unmatch_renewal'],
        'isAlert': json['is_alert'],
        'alertTypeName': json['alert_type_name'],
        'alertMessage': json['alert_message'],
        'lastArrivalDate': (json['last_arrival_date'] == null ? null : new Date(json['last_arrival_date'])),
        'lastShipDate': (json['last_ship_date'] == null ? null : new Date(json['last_ship_date'])),
    };
}

export function MstItemToJSON(json: any): MstItem {
    return MstItemToJSONTyped(json, false);
}

export function MstItemToJSONTyped(value?: MstItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delete_flg': value['deleteFlg'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'company_id': value['companyId'],
        'item_code': value['itemCode'],
        'item_name': value['itemName'],
        'sales_startdate': value['salesStartdate'] == null ? value['salesStartdate'] : value['salesStartdate'].toISOString(),
        'sales_enddate': value['salesEnddate'] == null ? value['salesEnddate'] : value['salesEnddate'].toISOString(),
        'longside': value['longside'],
        'shortside': value['shortside'],
        'height': value['height'],
        'weight': value['weight'],
        'spec': value['spec'],
        'max_pallet_quantity': value['maxPalletQuantity'],
        'pallet_quantity_face': value['palletQuantityFace'],
        'pallet_quantity_tier': value['palletQuantityTier'],
        'min_order_quantity': value['minOrderQuantity'],
        'order_unit_type': value['orderUnitType'],
        'case_lot': value['caseLot'],
        'order_unit_type_name': value['orderUnitTypeName'],
        'replace_item_code': value['replaceItemCode'],
        'replace_org_item_code': value['replaceOrgItemCode'],
        'old_item_code': value['oldItemCode'],
        'maker_name': value['makerName'],
        'jan': value['jan'],
        'jan_case': value['janCase'],
        'gtin_13': value['gtin13'],
        'gtin_14': value['gtin14'],
        'itf': value['itf'],
        'sdp': value['sdp'],
        'org_item_code': value['orgItemCode'],
        'maker_gln': value['makerGln'],
        'org_supplier_id': value['orgSupplierId'],
        'is_discontinued': value['isDiscontinued'],
        'is_muted': value['isMuted'],
        'supplier_company_id': value['supplierCompanyId'],
        'supplier_name': value['supplierName'],
        'remarks': value['remarks'],
        'recency_flg': value['recencyFlg'],
        'is_inactive': value['isInactive'],
        'unmatch_renewal': value['unmatchRenewal'],
        'is_alert': value['isAlert'],
        'alert_type_name': value['alertTypeName'],
        'alert_message': value['alertMessage'],
        'last_arrival_date': value['lastArrivalDate'] == null ? value['lastArrivalDate'] : value['lastArrivalDate'].toISOString(),
        'last_ship_date': value['lastShipDate'] == null ? value['lastShipDate'] : value['lastShipDate'].toISOString(),
    };
}

